


import { useState,useEffect ,useRef} from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SessionTimeoutWrapper from "./Components/SessionTimeoutWrapper";
import Layout from "./Components/Layout";

// AuthonticationScreens
import Login from "./Components/AuthonticationPages/Login"
import Register from "./Components/AuthonticationPages/Register";
import ForgotPassword from "./Components/AuthonticationPages/ForgotPassword";
import GoogleCallback from "./Components/AuthonticationPages/GoogleCallback";
import AdminPendingUsers from "./Components/AuthonticationPages/PendingUsers";

import AdminDashboard from "./Components/AdminPages/AdminDashboard";
import EmergencyDashboard from "./Components/AdminPages/EmergencyDashboard";
import ComplaintsDashboard from "./Components/AdminPages/ComplaintsDashboard";
import DiagnosticMasterUpload from "./Components/AdminPages/DiagnosticMasterUpload";
import ProfilePage from "./Components/AdminPages/ProfilePage";
import BookAppointment from "./Components/AdminPages/BookAppointment";
import ServicePricingChange from "./Components/AdminPages/ServicePricingChange";
import AuditLogs from "./Components/AdminPages/AuditLogsScreen";

// medicinelist screens
import MedicineListScreen from "./Components/MedicineDetailsPages/MedicineList";
import MedicineInsertionForm from "./Components/MedicineDetailsPages/MedicinesInsertionForm";
import AddMedicinesAdmin from "./Components/MedicineDetailsPages/AddMedicine";
// import PatientDetailsForm from "./Components/MedicineDetailsPages/PatientDetailsForm";
// prescription screens
import AdminPrescriptionOrders from "./Components/PrescriptionManagementPages/Prescriptioncheckbillgenerate";
import DiagnosticSampleBooking from "./Components/BookingPages/DiagonsticSampleBooking";

// Booking part
import PrescriptionUploadScreen from "./Components/BookingPages/precriptionUploadScreen";
import MedicineOrderTypeScreen from "./Components/BookingPages/MedicineOrderTypeScreen";
import MedicineDeliveryAddressScreen from "./Components/BookingPages/MedicineDeliveryAddressScreen";
import MedicinePaymentScreen from "./Components/BookingPages/MedicinePaymentScreen";
import MedicineOrderSuccessScreen from "./Components/BookingPages/MedicineOrderSuccessScreen";
import ServiceSelectionScreen from "./Components/BookingPages/ServiceSelectionScreen";
import PaymentMethodSelection from "./Components/BookingPages/ServicePaymentScreen";
import BookingStatusScreen from "./Components/BookingPages/BookingStatusScreen";
import CancelledOrders from "./Components/AdminPages/CancelledOrders";


// OrdersManagement
import OrdersManagement from "./Components/OrderDetailsPage/OrdersSceen";
import MedicineOrdersScreen from "./Components/OrderDetailsPage/MedicineOrdersScreen";
import Welcomefile from "./Components/AdminPages/welcomefile";


import DeliveryAgentsManagement from "./Components/DeliveyAgentScreens/DeliveryAgentsManagement";
import DeliveryOrdersManagement from "./Components/DeliveyAgentScreens/OrdersManagement";
import OrderTracking from "./Components/DeliveyAgentScreens/OrderTracking";

import MedicineAdminScreens from "./Components/MedicineDiagnosticAdminScreens/MedicineAdmindashbaord";
import DiagnosticAdminScreens from "./Components/MedicineDiagnosticAdminScreens/DiagnosticAdminDashboard";
import {
  AgentAssignmentAccept,
  AgentAssignmentReject,
  AgentOrderPickup,
  AgentOrderDeliver,
} from "./Components/DeliveyAgentScreens/AgentAssignmentResponse";

// Subscription & promotion
import SubscriptionManagement from "./Components/SubscriptionManagement/SubscriptionMangement";
import PromotionDashboard from "./Components/SubscriptionManagement/PromotionDashboard";
import UserPromotions from "./Components/SubscriptionManagement/UserPromotions";

// inperson,distributor pages data
import POSMedicineSystem from "./Components/InPersonPages/POSMedicineSystem";
import DistributorList from "./Components/DistributorPages/DistributorList";
import DistributorForm from "./Components/DistributorPages/DistributorForm";
import DistributorDetails from './Components/DistributorPages/DistributorDetails';


import CreatePurchaseOrder from "./Components/PurchaseOrderPages/CreatePurchaseOrder";
import PurchaseOrderList from "./Components/PurchaseOrderPages/Purchaseorderlist";
import PurchaseOrderDetail from "./Components/PurchaseOrderPages/Purchaseorderdetail";
import ReceiveGoods from "./Components/PurchaseOrderPages/Receivegoods";
import StockSuggestions from "./Components/PurchaseOrderPages/Stocksuggestions";
import GlobalLowStockAlert from "./Components/GlobalLowStockAlert";
import PaymentDashboard from "./Components/PaymentDashboardPages/PaymentDashboard";
//delivery agent pages


import DeliveryAgentDashboard from "./Components/DeliveryPersonDashboard/Deliveryagentdashboard";
import IssueReporting from "./Components/DeliveryPersonDashboard/Issuereporting";

import SampleCollection from "./Components/DeliveryPersonDashboard/PhlebotomistScreens/SampleCollection";
import LabTransfer from "./Components/DeliveryPersonDashboard/PhlebotomistScreens/LabTransfer";
import PhlebotomistDashboard from "./Components/DeliveryPersonDashboard/PhlebotomistScreens/PhlebotomistDashboard";


import PackageBookings from "./Components/BookingPages/PackagesBooking";
import AdminFeedbackDashboard from "./Components/AdminPages/AdminFeedbackDashboard";
import AyujaConfigSettings from "./Components/MedicineDetailsPages/AyujaConfigSettings";
import AdminHealthContent from "./Components/HealthPackages/Adminhealthcontent";

import MyPackageBookings from "./Components/PackageBookingPages/packagebooking";

// NursingPhysiotheraphy
import NursingPhysioAdmin from "./Components/NursingPhysiotheraphy/Bookedservices";
import NursingPhysiotherapyPage from "./Components/NursingPhysiotheraphy/NursingPhysioBooking";
import NursingPhysioServicesAdmin from "./Components/NursingPhysiotheraphy/Nursingphysioservicesadmin";
import HealthServicesManagement from "./Components/AdminPages/Healthservicesmanagement";
import StaffUpdatePage from "./Components/NursingPhysiotheraphy/Staffupdatepage";
import WhatsappDashboard from "./Components/watsappDashboard/WhatsappDashboard";
import AdminMedicineRequests from "./Components/MedicineDetailsPages/AdminMedicineRequests";

import VendorReturns from "./Components/MedicineDetailsPages/Vendorreturns";


import { UserProvider } from "./context/UserContext";
import { registerWebToken } from "./firebase";
import axios from "axios";
import NotificationManagement from "./Components/AdminPages/WeeklyNotificationManagement";
import CommunityServices from "./Components/AdminPages/CommunityManagement";
import GroceryManagement from "./Components/AdminPages/GroceryManagement";
import PendingOrdersReview from "./Components/AdminPages/PendingOrderManagement";

import EnglishDashboard from "./Components/EnglishTutorials/EnglishDashboard";
import EnglishModulePage from "./Components/EnglishTutorials/EnglishModulePage";
import EnglishQuizPage from "./Components/EnglishTutorials/EnglishQuizPage";

import AppointmentData from "./Components/DoctorAppointmentService/AppointmentData";
import DoctorAppointmentsAdmin from "./Components/DoctorAppointmentService/DoctorAppointmentsAdmin";
import LaundryAdmin from "./Components/LaundryScreens/LaundryAdmin";
import LaundryOrders from "./Components/LaundryScreens/LaundryOrders";
import FestivalAdmin from "./Components/AdminPages/FestivalManagement";
const App = () => {
  const baseUrl=process.env.REACT_APP_ALERT_TONE
    const audioRef = useRef(null);
    const  [username,setUsername] =useState()

  useEffect(() => {
  const ws = new WebSocket(`${baseUrl}/ws/admin-notifications`);
    console.log(`${baseUrl}/ws/admin-notifications`)
  ws.onopen = () => {
    console.log("WS");
  };

  ws.onmessage = (event) => {
    const data = JSON.parse(event.data);
    console.log("dfghgvcghg")
    if (data.type === "new_user_registered") {
       audioRef.current?.play().catch(err => console.log("Audio error:", err));

      }
    console.log("WS message:", data);
    console.log("WS message: audio", data);
  };

  ws.onerror = (err) => {
    console.log("WS error:", err);
  };

  ws.onclose = () => {
    console.log("WS closed");
  };

  return () => ws.close();
}, []);
  // useEffect(() => {
  //   const checkAuth = async () => {
  //     try {
  //       const res = await axios.get("http://192.168.1.49:5001/api/flask/auth/protected", {
  //         withCredentials: true, 
  //       });
  //       setUser(res.data.user); // store user info in state
  //     } catch (err) {
  //       console.log("Not authenticated");
  //       setUser(null);
  //     } 
  //   };

  //   checkAuth();
  // }, []);
 const [user, setUser] = useState(null);
 useEffect(() => {
  console.log("calling the firebase fun")
  registerWebToken();
}, []);
  return (
    <>
    <audio ref={audioRef} src="/notification_tone.mp3" preload="auto" />
    <UserProvider>
    <Router> 
       <SessionTimeoutWrapper>
                <GlobalLowStockAlert />
        <Routes>
          
        <Route element={<Layout username={username} setUsername={setUsername} />}>
          <Route path="/" element={<Login/>} />
           {/* AuthonticationScreens */}
          <Route path="/Login" element={<Login/>}/>
          <Route path="/Register" element={<Register/>}/>
          <Route path="/ForgotPassword" element={<ForgotPassword/>}/>
          <Route path="/google/callback" element={<GoogleCallback setUser={setUser} />} />
          <Route path="/PendingUsers" element={<AdminPendingUsers/>}/>
          

          <Route path="/admin-dashboard" element={<AdminDashboard/>}/>
          <Route path="/emergency-dashboard" element={<EmergencyDashboard/>}/>
          <Route path="/complaints-dashboard" element={<ComplaintsDashboard/>}/>
          <Route path="/diagnostic-masterdata" element={<DiagnosticMasterUpload/>}/>
          <Route path="/profile-details" element={<ProfilePage setUsername={setUsername}/>}/>
          <Route path="/booking-appointment" element={<BookAppointment/>}/>
          <Route path="/price-changes" element={<ServicePricingChange/>}/>
          

          {/* medicine routes */}
        <Route path="/medicine-list" element={<MedicineListScreen/>}/>
        <Route path="/medicine-insertion-form" element={<MedicineInsertionForm/>}/>
        <Route path="/add-medicine" element={<AddMedicinesAdmin/>}/>
        <Route path="/prescription-billing" element={<AdminPrescriptionOrders/>}/>
        <Route path="/diagnostic-booking" element={<DiagnosticSampleBooking/>}/>
        <Route path="/medicine-requests-admin" element={<AdminMedicineRequests />} />
        <Route path="/VendorReturns" element={<VendorReturns />} />
        <Route path="/payment-dashboard" element={<PaymentDashboard />} />


        {/* <Route path="/patient-details-form" element={<PatientDetailsForm/>}/> */}
        
        {/* Booking part */}
        <Route path="/MedicinePayment" element={<MedicinePaymentScreen/>}/>
        <Route path="/medicine-order-success" element={<MedicineOrderSuccessScreen/>}/>
        <Route path="/medicine-delivery-address" element={<MedicineDeliveryAddressScreen/>}/>
        <Route path="/medicine-order-type" element={<MedicineOrderTypeScreen/>}/>
        <Route path="/prescription-upload" element={<PrescriptionUploadScreen/>}/>
        <Route path="/select-booking" element={<ServiceSelectionScreen/>}/>
        <Route path="/select-payment-method" element={<PaymentMethodSelection/>}/>
        <Route path="/booking-status" element={<BookingStatusScreen/>}/>
        <Route path="/cancelled-orders" element={<CancelledOrders/>}/>
        
        {/* OrdersManagement */}
        <Route path="/orders-management" element={< OrdersManagement/>}/>
        <Route path="/medicine-orders-management" element={< MedicineOrdersScreen/>}/>
        <Route path="/AyujaConfigSettings" element={< AyujaConfigSettings/>}/>
        <Route path="/NotificationManagement" element={<NotificationManagement/>}/>

        
        {/* MedicineAdminScreens */}
        <Route path="/medicine-admin-dashboard" element={< MedicineAdminScreens/>}/>
        <Route path="/diagnostic-admin-dashboard" element={< DiagnosticAdminScreens/>}/>

        <Route path="/agent/assignment/accept" element={<AgentAssignmentAccept />} />
        <Route path="/agent/assignment/reject" element={<AgentAssignmentReject />} />
        <Route path="/agent/order/pickup" element={<AgentOrderPickup />} />
        <Route path="/agent/order/deliver" element={<AgentOrderDeliver />} />

        <Route path="/delivery-agent-management" element={< DeliveryAgentsManagement/>}/>
        <Route path="/delivey-orders-management" element={< DeliveryOrdersManagement/>}/>
        <Route path="/track/:orderId/:orderType" element={<OrderTracking />} />
        
        {/* Subscription & promotion */}
        <Route path="/subscription-management" element={<SubscriptionManagement />} />
        <Route path="/UserPromotions" element={<UserPromotions />} />
        <Route path="/PromotionDashboard" element={<PromotionDashboard />} />
        <Route path="/WhatsappDashboard" element={<WhatsappDashboard />} />
        <Route path="/pending-orders" element={<PendingOrdersReview />} />
        {/* <Route path="/english" element={<EnglishDashboard />} /> */}

        
        <Route path="/welcomefile" element={< Welcomefile/>}/>
        
        {/* inperson routes */}

        <Route path="/POSMedicineSystem" element={< POSMedicineSystem/>}/>
        <Route path="/DistributorList" element={< DistributorList/>}/>
        <Route path="/distributors/add" element={<DistributorForm />} />
        <Route path="/distributors/edit/:id" element={<DistributorForm />} />
        <Route path="/distributors/:id" element={<DistributorDetails />} />

        <Route path="/purchase-orders/create" element={<CreatePurchaseOrder />} />
        <Route path="/purchase-orders" element={<PurchaseOrderList />} />
        <Route path="/purchase-orders/:po_id" element={<PurchaseOrderDetail />} />
        <Route path="/purchase-orders/:po_id/receive" element={<ReceiveGoods />} />
        <Route path="/StockSuggestions" element={<StockSuggestions />} />


        {/* delivery person dashbord pages */}
        
        <Route path="/deliveryagent-dashboard" element={<DeliveryAgentDashboard />} />
        <Route path="/delivery-report-issue" element={<IssueReporting />} />
        <Route path="/sample-collection/:orderId" element={<SampleCollection />} />
        <Route path="/lab-transfer" element={<LabTransfer />} />
        <Route path="/PhlebotomistDashboard" element={<PhlebotomistDashboard />} />
        <Route path="/PackageBookings" element={<PackageBookings />} />
        <Route path="/AdminFeedbackDashboard" element={<AdminFeedbackDashboard />} />

        <Route path="/AdminHealthContent" element={<AdminHealthContent />} />
        <Route path="/MyPackageBookings" element={<MyPackageBookings />} />
        {/* NursingPhysioAdmin */}
        <Route path="/NursingPhysiotheraphy" element={<NursingPhysioAdmin />} />
        <Route path="/NursingPhysioBooking" element={<NursingPhysiotherapyPage/>}/>
        <Route path="/NursingPhysioServices" element={<NursingPhysioServicesAdmin/>}/>
        <Route path="/HealthServicesManagement" element={<HealthServicesManagement />} />    
        <Route path="/Audit-logs" element={<AuditLogs />} />    
        <Route path="Community-services" element={<CommunityServices/>}/>



         <Route path="/english" element={<EnglishDashboard />} />
        <Route path="/english/:moduleId" element={<EnglishModulePage />} />
        <Route path="/english/:moduleId/quiz" element={<EnglishQuizPage />} />


          <Route path="/appointmentdata" element={<AppointmentData />} />
          <Route path="/doctor-appointments" element={<DoctorAppointmentsAdmin />} />

          <Route path="/laundry-data" element={<LaundryAdmin />} />
          <Route path="/laundry-orders" element={<LaundryOrders />} />
          <Route path="/grocery-management" element={<GroceryManagement />} />

          <Route path="/festival-management" element={<FestivalAdmin />} />

        
          </Route>
          <Route path="/staff-update/:bookingRef" element={<StaffUpdatePage />} />
        {/* </Route> */}
          </Routes>
        </SessionTimeoutWrapper>
    </Router>
    </UserProvider>

</>

  );
};

export default App;


